jQuery(function ($) {
	var selects = document.querySelectorAll(".archive-recipes-search-bar__select");

	selects.forEach(function (select) {
		select.addEventListener("change", function () {
			var form = select.closest("form");
			form.submit();

			jQuery(".archive-recipes__recipes-container").append('<div class="loader">Loading...</div>');
		});
	});

	$(".archive-recipes-search-bar__filters-title").on("click", function () {
		var $target = $(".archive-recipes-search-bar__container");

		if ($(this).hasClass("expanded")) {
			collapseAccordion($target);
			$(this).removeClass("expanded");
		} else {
			expandAccordion($target);
			$(this).addClass("expanded");
		}
	});

	function expandAccordion($target) {
		$target.height($target.prop("scrollHeight"));
		$target.on("transitionend", function () {
			$target.off("transitionend");
			$target.height("auto");
		});
	}

	function collapseAccordion($target) {
		$target.height($target.prop("scrollHeight"));
		setTimeout(function () {
			$target.height(0);
		}, 0);
	}
});
